import { SET_INCENTIVE } from '../actions/types';

const initialState = {
	incentiveData: [
		{
			key: '',
			label: '',
			title: '',
			shortTitle: '',
			offerDetails: '',
			disclaimer: '',
			effectiveDate: '',
			expirationDate: ''
		}
	]
};

export default function incentive(state = initialState, action) {
	if (!action.error) {
		switch (action.type) {
			case SET_INCENTIVE:
				return {
					...state,
					incentiveData: [...state.incentiveData, ...action.payload]
				};

			default:
		}
	}

	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/incentive.js